export const SIZE_PICKER_MODAL = 'sizePickerModal';

export const SET_CURRENT_LENGTH_DETAIL = 'SET_CURRENT_LENGTH_DETAIL';
export const SET_CURRENT_SIZE_DETAIL = 'SET_CURRENT_SIZE_DETAIL';
export const SET_CURRENT_AVAILABLE_LENGTHS = 'SET_CURRENT_AVAILABLE_LENGTHS';
